import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';

import { TSIconModule } from '../ts-icon/ts-icon.module';

export type TsCalloutBoxType = 'success' | 'warning' | 'error' | 'info';

const DEFAULT_ICONS: Record<TsCalloutBoxType, string> = {
  success: 'check_circle',
  warning: 'warning',
  error: 'error',
  info: 'info',
};

const CONTAINER_CLASSES: Record<TsCalloutBoxType, string> = {
  success: 'bg-green-50 text-green-700 border-green-100',
  warning: 'bg-yellow-50 text-yellow-700 border-yellow-100',
  error: 'bg-red-50 text-red-700 border-red-100',
  info: 'bg-blue-50 text-blue-700 border-blue-100',
};

@Component({
  selector: 'ts-callout-box',
  standalone: true,
  imports: [NgClass, TSIconModule],
  templateUrl: './ts-callout-box.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TsCalloutBoxComponent {
  readonly type = input<TsCalloutBoxType>('info');
  readonly title = input<string | undefined>();
  readonly icon = input<string | undefined>();
  readonly showIcon = input<boolean>(true);

  readonly iconName = computed<string>(() => this.icon() ?? DEFAULT_ICONS[this.type()]);
  readonly containerClasses = computed<string>(() => CONTAINER_CLASSES[this.type()]);
}
